import Vue from "vue";
import { ImagePreview } from "vant";
import wx from "weixin-js-sdk";
import authAjax from "@/apis/auth";

import imageCompression from "browser-image-compression";
import { get } from "lodash";
import { handleExecHandler } from "../common/handles";
// import { mShopIdKey } from "../apis/merchant";
// import { getLangText } from "../common/langue";
const options = {
  // maxSizeMB: 1, // (default: Number.POSITIVE_INFINITY)
  maxWidthOrHeight: 1000, // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
  // useWebWorker: boolean, // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
  // maxIteration: number, // optional, max number of iteration to compress the image (default: 10)
  // exifOrientation: number, // optional, see https://stackoverflow.com/a/32490603/10395024
  // onProgress: Function, // optional, a function takes one progress argument (percentage from 0 to 100)
  fileType: "png", // optional, fileType override
};

let loginUserInfoCache = null;
let loginUserInfoPromise = null;

let workflowProcessCache = null;

export const getLoginUserInfo = async (refresh) => {
  if (refresh) {
    loginUserInfoCache = null;
    loginUserInfoPromise = null;
  }

  if (loginUserInfoCache) {
    return loginUserInfoCache;
  }

  if (loginUserInfoPromise) {
    return loginUserInfoPromise;
  }

  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  loginUserInfoPromise = authAjax
    .get("/api/wxapp/getUserinfo", {
      params: {
        memberNo: loginUserInfo.memberNo,
        phone: loginUserInfo?.phone || "",
      },
    })
    .then((res) => {
      console.log("1111");
      loginUserInfoCache = res.data.data;
      return loginUserInfoCache;
    })
    .catch((err) => {
      console.log("getLoginUserInfo", err);
      loginUserInfoCache = null;
      loginUserInfoPromise = null;
      return Promise.reject(err);
    });

  return loginUserInfoPromise;
};

const mixin = {
  mounted() {
    if (this.$route) {
      const customerId = this.$route.query.customerId;
      if (customerId) {
        this.customerId = customerId;
      }
    }
  },
  data() {
    let userinfo = {};
    try {
      const userinfoStr = localStorage.getItem("loginUserInfo");
      if (userinfoStr) {
        userinfo = JSON.parse(userinfoStr);
      }
    } catch (error) {
      console.log("error", error);
    }

    return {
      allCard: [],
      vCard: [],
      yktCard: [],
      customerId: sessionStorage.getItem("customerId") || userinfo.customerId,
      loginUserMemberNo: userinfo.memberNo,
    };
  },
  watch: {
    customerId() {
      sessionStorage.setItem("customerId", this.customerId);
    },
  },
  computed: {
    // _mShopId() {
    //   const shopId = this.$store.state.mShopId;
    //   if (shopId) {
    //     return shopId;
    //   }
    //   const mShopId = sessionStorage.getItem(mShopIdKey);
    //   if (mShopId && mShopId !== "null" && mShopId !== "undefined") {
    //     return Number.parseInt(mShopId);
    //   }

    //   const localShopId = localStorage.getItem("shopId");

    //   if (
    //     localShopId &&
    //     localShopId !== "null" &&
    //     localShopId !== "undefined"
    //   ) {
    //     return Number.parseInt(localShopId);
    //   }

    //   return null;
    // },
    _domainBaseUrl() {
      const baseURL =
        location.origin +
        location.pathname
          .replace("h5", "")
          .replace("h6", "")
          .replace("index.html", "")
          .replace(/\/+/g, "/")
          .replace(/\/$/, "");
      // console.log('baseURL', baseURL);
      if (process.env.NODE_ENV === "development") {
        // VUE_APP_DEV_EDITOR_MENU_CONFIG_APPID
        return `http://${process.env.VUE_APP_DEV_EDITOR_MENU_CONFIG_APPID}`;
      }
      return baseURL;
    },
    // _config 开头的都是注入的配置
    _config_page() {
      console.log("this.$route.meta.key", this.$route.meta.key);
      console.log("this.$route.path", this.$route.path);
      const key = this.$route.meta.key;
      // console.log("this.$store.state.configs", this.$store.state.configs);
      const config = get(get(this.$store.state, "configs.pages", {}), key, {});
      return config || {};
    },
    _page_title() {
      return get(this._config_page, "pageTitle", this.$route.meta.title);
    },
    _config_global() {
      const config = this.$store.state.configs.global;
      return config || {};
    },
    _config_global_base() {
      const config = this._config_global;
      console.log("config", config);
      return get(config, "basic", {});
    },
    _config_appInfo() {
      const config = this._config_global;
      console.log("config", config);
      return {
        appLogo: this.$tt(
          config,
          "basic.appLogo",
          require("@/assets/imgs/logo.jpeg")
        ),
        appName: this.$tt(config, "basic.appName", "智慧餐厅"),
        appEntry: this.$tt(config, "basic.appEntry", "/card/selectBranch"),
      };
    },
    _config_menu_configs() {
      return get(this.$store.state, "menuConfigs", []);
    },
    _config_menu_routers_configs() {
      const menuConfigs = this._config_menu_configs;
      const routers = menuConfigs.filter((item) => {
        return !/^MENU_TYPE/.test(item.parentMenuCode);
      });
      return routers;
    },
    _config_menu_tabbar_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_TABBAR");
    },

    _config_menu_me_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_MINE");
    },

    _config_menu_biz_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_HOME");
    },

    _config_menu_biz_service_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_HOME_SERVICE");
    },
    _config_menu_biz_health_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_HOME_HEALTH");
    },
    // CATER
    _config_menu_biz_cater_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_HOME_CATER");
    },

    // MENU_CARD_PAGE
    _config_menu_card_home_routers_configs() {
      if (this._config_menu_routers_configs) {
        // bug: 为了保证computed及时更新，这里随便if了一下
      }
      return this._getH5MenuByLocationKey("MENU_CARD_PAGE");
    },

    _config_app_home() {
      const routers = this._config_menu_routers_configs;
      const home = routers[0];
      return home;
    },
    _is_pc() {
      return isPc();
    },
    _config_app_login_path() {
      if (this.isPc) {
        return "/pc/login";
      }
      return this._config_global_base.loginPath || "/login";
    },
    _config_app_home_path() {
      if (this._is_pc) {
        return {
          type: "router",
          handle: "/pc/main",
        };
      }

      const home = this._config_app_home;
      return {
        type: home.styleJson.menuType,
        handle: home.styleJson.path,
      };
    },
    _config_app_orderMode() {
      const config = this._config_global_base;
      return get(config, "orderMode", "single");
    },
  },
  methods: {
    _getH5MenuByLocationKey(locationKey) {
      const routers = this._config_menu_routers_configs;

      const meMenus = routers.filter((item) => {
        return item.parentMenuCode === locationKey;
      });
      // console.log(meMenus,'meMenus==meMenus');
      

      return meMenus
        .map((item) => {
          const styleJson = item.styleJson || {};
          return {
            ...item,
            handle: styleJson.path,
            handlePc: styleJson.pathPc, // 仅限pc 且type为url
            iconKey: styleJson.menuIcon,
            icon: styleJson.menuIconValue || styleJson.menuIcon,
            title: styleJson.menuName,
            type: styleJson.menuType,
          };
        })
        .filter((item) => {
          if (item.type !== "url") {
            return true;
          }
          if (this._is_pc) {
            return item.handlePc;
          }
          return item.handle;
        });
    },
    async handleExecInitQueryHandleService(handle) {
      const id = handle.id;
      const serviceType = handle.serviceType;
      const taskId = handle.taskId;
      const isLast = handle.isLast;

      if (!id || !serviceType) {
        throw new Error("id or serviceType is empty");
      }
      if (this._is_pc) {
        // pc端
        localStorage.setItem("exec_init_handle", JSON.stringify(handle));
        await this.handleExecHomeReal();
      } else {
        this.$router.replace({
          path: "/workflow/detail",
          query: {
            procInsId: id,
            actionProcessed: serviceType === "todo" ? 1 : "",
            taskId: taskId,
            isLast: isLast,
          },
        });
      }
    },
    async handleExecInitQueryHandle(handle) {
      // handle = {"serviceType":"todo","id":"123","type":"service"}
      if (!handle) {
        return false;
      }

      if (handle.type === "service") {
        // 服务，跳转到服务
        await this.handleExecInitQueryHandleService(handle);
        return true;
      }

      return false;
    },
    async handleExecHome(handle) {
      await this.$store.dispatch("getCustomerH5Menu");
      const status = await this.handleExecInitQueryHandle(handle);
      if (status) {
        return;
      }
      await this.handleExecHomeReal();
    },
    async handleExecHomeReal() {
      const home = this._config_app_home_path;
      if (!home) {
        this.$toast("未找到首页，请联系管理员");
        return;
      }
      this.$handleExec(home, true);
    },
    $tt(data, key, defaultText) {
      return getLangText(data, key, defaultText);
    },
    async imgSizeToBase64(file) {
      const _file = await imageCompression(file, options);
      // const _file = file;
      const base64 = await imageCompression.getDataUrlFromFile(_file);
      return base64;
    },
    imgShow(imglist) {
      ImagePreview({
        images: imglist,
      });
    },
    async getCards() {
      let { data: resData } = await this.$http.get(
        "/api/wxapp/paycard/list/" + this.customerId
      );
      if (resData.code == 200) {
        // this.allCard = resData.data || [];
        const list = resData.data;
        this.allCard = this.toOneArr(list);
        this.vCard = this.typeFilterList(list, 0);
        this.yktCard = this.typeFilterList(list, 2);
      }
    },
    toOneArr(list) {
      const allCard = list.reduce((p, c) => {
        const currList = c.payCards || [];
        return [...p, ...currList];
      }, []);
      return allCard;
    },
    typeFilterList(cards, type = 0) {
      const vres = cards.filter(function(item) {
        return item.cardType === type;
      });
      if (vres.length) {
        return vres[0].payCards;
      }
      return [];
    },
    // 检查是否是ios
    checkIsIOS() {
      return /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
    },
    // 设置滚动元素（兼容性问题）
    setRootScrollTop(value) {
      this.setScrollTop(window, value);
      this.setScrollTop(document.body, value);
    },
    // 设置滚动位置
    setScrollTop(el, value) {
      if ("scrollTop" in el) {
        el.scrollTop = value;
      } else {
        el.scrollTo(el.scrollX, value);
      }
    },
    // 获取滚动位置
    getRootScrollTop() {
      return (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      );
    },

    $handleGetParams() {
      const params = {};
      let rolesStr = localStorage.getItem("loginUserInfo");
      let customerId =
        this.$route.query.customerId ||
        sessionStorage.getItem("customerId") ||
        localStorage.getItem("customerId");
      let customerName = "";
      if (rolesStr) {
        try {
          customerId = JSON.parse(rolesStr).customerId;
          customerName = JSON.parse(rolesStr).username;
        } catch (error) {
          console.log("error", error);
        }
      }
      params.customerId = customerId;
      params.customerName = customerName;
      const shopId = localStorage.getItem("shopId");
      params.shopId = shopId;
      params.branchId = sessionStorage.getItem("branchId");
      params.xcxOpenId = localStorage.getItem("xcxOpenId");

      return params;
    },

    async $handleGetCardInfo(shopId, customerId) {
      if (!customerId || customerId === "undefined" || customerId === "null") {
        return;
      }
      const $customerCardData = Vue.$customerCardData;
      if ($customerCardData) {
        return $customerCardData;
      }
      const { data } = await this.$logina.post(
        "/api/wxapp/customer/getBalanceV3",
        {
          shopId,
          customerId,
        }
      );
      Vue.$customerCardData = data.data || {};
      return data.data;
    },

    async $getLoginUserInfo(refresh) {
      return getLoginUserInfo(refresh);
    },

    async $handleExec(menu, replace) {
      const language = localStorage.getItem('language');
      console.log("$handleExec", menu);
      // loading
      const loading = this.$toast.loading({
        message: language == 'CN' ? "加载中..." : "Loading...",
        forbidClick: true,
        duration: 0,
      });

      try {
        // 这里把参数处理好
        const baseParams = this.$handleGetParams();
        const cardInfoParams = await this.$handleGetCardInfo(
          baseParams.shopId,
          baseParams.customerId
        );

        const mergeParams = {
          ...baseParams,
          ...cardInfoParams,
        };

        if (["url"].includes(menu.type)) {
          // 处理跳转
          location.href = `${menu.handle}?customerId=${baseParams.customerId ||
            ""}&shopId=${baseParams.shopId || ""}&customerName=${
            mergeParams.customerName
          }`;
        } else if (["router", "route"].includes(menu.type)) {
          // 用于测试
          if (replace) {
            this.$router.$system.replace({
              path: menu.handle,
              query: cardInfoParams,
            });
          } else {
            this.$router.$system.push({
              path: menu.handle,
              query: cardInfoParams,
            });
          }
        } else if (menu.type === "wx") {
          // params
          // 这里暂时写死参数，后期尝试模版
          wx.miniProgram.navigateTo({
            url: `${menu.handle}?shopId=${
              mergeParams.shopId
            }&cardName=${mergeParams.cardName ||
              mergeParams.cardNo}&customerId=${mergeParams.customerId}&phone=${
              mergeParams.phone
            }&customerName=${mergeParams.customerName}&cardId=${
              mergeParams.cardId
            }&cardNo=${mergeParams.cardNo}&openId=${mergeParams.xcxOpenId}`,
          });
        } else if (["handle", "function"].includes(menu.type)) {
          handleExecHandler(menu.handle, this);
        } else if (["workflow"].includes(menu.type)) {
          this.$handleExecWorkFlow(menu);
        } else {
          console.warn("未知的类型", menu.type);
        }
      } finally {
        loading.clear();
      }
    },

    async $handleExecWorkFlow(menu) {
      if (!workflowProcessCache) {
        const workflowProcessCacheRes = await this.$flowapi.get(
          "/workflow/process/list?pageNum=1&pageSize=1000"
        );
        workflowProcessCache = workflowProcessCacheRes.rows;
      }

      const process = workflowProcessCache.find(
        (item) => item.category === menu.handle
      );
      if (!process) {
        this.$toast("未找到流程");
        console.warn("未找到流程", menu);
        return;
      }

      this.$router.$system.push({
        path: "/workflow/create",
        query: {
          definitionId: process.definitionId,
          deployId: process.deploymentId,
          title: menu.title,
          category: process.category,
        },
      });
    },

    $replacePic(img) {
      // 将图片域替换成本地域名
      const res = (img || "").replace(
        /^https?:\/\/(.*?)\/(.*)/,
        `${location.origin}/$2`
      );
      return res;
    },
  },
};
Vue.mixin(mixin);
